export default function Card({ children, className = '' }) {
    return (
        <div className={`rounded-xl shadow-lg bg-red ${className}`}>
            {children}
        </div>
    );
}
